import { useSelector } from 'react-redux';
import { getProjectDetails } from '@/store/projectDetails';
import { useAuth } from '@/hooks';
import { useAtsPermissions } from '@/hooks/useAtsPermissions';
const useAtsProjectPermissions = () => {
  const { currentProject } = useSelector(getProjectDetails);
  const { projectsPermissions } = useAtsPermissions();
  const {
    can_archive,
    can_clone,
    can_edit,
    project_collaborators = [],
  } = currentProject?.data;

  const { currUser } = useAuth();

  const getProjectOwnerId = (collaborators) => {
    const owner = collaborators?.find(
      (proj) => proj.access === 'project_owner'
    );
    return owner?.user?.id;
  };

  const isProjectCreator =
    getProjectOwnerId(project_collaborators) === currUser?.id;

  const listProspects = projectsPermissions?.list_prospects;
  const addProspect = projectsPermissions?.add_prospect;
  const canArchiveProjects = can_archive || isProjectCreator;

  const canEditProject = () => {
    return can_edit || isProjectCreator;
  };
  const canUpdateProjectPermisssion = () => {
    return projectsPermissions.update;
  };

  const canCloneProject = () => {
    return can_clone || isProjectCreator;
  };

  const canCloneProjectPermission = () => {
    return projectsPermissions.clone;
  };

  const canArchiveProject = () => {
    return canArchiveProjects;
  };

  const canUpdateReviewStatus = () => {
    return canArchiveProjects;
  };

  const isProjectInternalUser = () => {
    return projectsPermissions?.internal_users;
  };

  const canCreateReview = () => {
    return projectsPermissions?.create_review;
  };

  const showAddCandidateButton = () => {
    return listProspects;
  };

  const showAddToProjectInContacts = () => {
    return addProspect;
  };
  const canCreateProject = () => {
    return projectsPermissions.create;
  };

  const canViewProjectsListScreen = () => {
    return projectsPermissions?.index;
  };

  const canRemoveFromProject = () => {
    return projectsPermissions.remove_prospect;
  };

  const canArchiveProjectWithPermissions = () => {
    return projectsPermissions.archive;
  };

  return {
    canEditProject,
    canCloneProject,
    canArchiveProject,
    isProjectInternalUser,
    showAddCandidateButton,
    showAddToProjectInContacts,
    canCreateReview,
    canCreateProject,
    canUpdateReviewStatus,
    canViewProjectsListScreen,
    canRemoveFromProject,
    canUpdateProjectPermisssion,
    canCloneProjectPermission,
    canArchiveProjectWithPermissions,
  };
};
export default useAtsProjectPermissions;
